import React from "react";
import ParticlesBg from "particles-bg";

const SprinkleEffect = () => {
  return (
    <>
      <ParticlesBg type="polygon" bg={true} />
    </>
  );
};

export default SprinkleEffect;
